<script setup lang="ts">
  import { Input } from '@ui/components/input';
  import type { InputProps } from '@ui/components/input';
  import { cn } from '@ui/utils/utils';

  const props = defineProps<InputProps>();
</script>

<template>
  <Input
    data-slot="input-group-control"
    v-bind="props"
    :class="
      cn(
        'flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent',
        props.class,
      )
    "
  />
</template>
